export default [
  { label: 'Simple', value: 'simple' },
  { label: 'Cuotas', value: 'installments' },
  { label: 'Permanente', value: 'permanent' }
];
